/** Unwrap checkout-quote API payload (direct body or `{ data }` wrapper). */
export function normalizeCheckoutQuoteResponse(payload) {
	if (!payload || typeof payload !== 'object') {
		return null;
	}

	if (payload.grossAmount != null) {
		return payload;
	}

	if (payload.data && payload.data.grossAmount != null) {
		return payload.data;
	}

	return null;
}

export function formatCheckoutVatRate(vatRatePct) {
	const rate = Number(vatRatePct);
	return Number.isInteger(rate) ? String(rate) : rate.toFixed(1);
}

export function formatCheckoutAmount(currencyCode, amountCents) {
	const currency = currencyCode || 'CHF';
	return `${(amountCents / 100).toFixed(2)} ${currency}`;
}

/** Payable amount for the offer card (gross from quote when loaded). */
export function getCheckoutOfferPriceCents({ offer, quote }) {
	if (quote?.grossAmount != null) {
		return quote.grossAmount;
	}

	return offer?.amount ?? 0;
}

/** Format offer-card price in major units (uses quote gross when available). */
export function formatCheckoutOfferPrice({ offer, quote }) {
	return (getCheckoutOfferPriceCents({ offer, quote }) / 100).toFixed(2);
}

/** Format payable gross for buttons and labels (e.g. `3.90 CHF`). */
export function formatCheckoutGrossLabel({ quote, currencyCode, grossAmountCents }) {
	const currency = quote?.currencyCode || currencyCode || 'CHF';
	const grossCents = quote?.grossAmount != null ? quote.grossAmount : grossAmountCents;

	return formatCheckoutAmount(currency, grossCents);
}

/** VAT suffix next to offer price; null when quote has no VAT. */
export function formatCheckoutVatSuffixLabel({ quote, trans }) {
	if (!quote || Number(quote.vatAmount) <= 0) {
		return null;
	}

	return trans('payments.checkout.vat_included_suffix', {
		rate: formatCheckoutVatRate(quote.vatRatePct),
	});
}
